<!--
 * @Author: 
 * @LastEditTime: 2023-06-28 16:40:19
 * @Description: 台账相关功能操作
-->
<template>
  <div></div>
</template>

<script>
import {
  drawTextLabel,
  drawMarker,
  updateMarker,
  destroyMarker,
  getItemPosByCode,
} from '../js/drawUtil'
import LocalSense from '@/services/baoChang/localSense'
import DocumentService from '@/services/DocumentService'
export default {
  name: 'LedgerRelated',
  props: {
    comPlayer: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      player: null,
      // 缺陷台账数据集合
      markerQXTZInfos: [],
      markerQXTZDatas: [],
      QXTZTimer: null, // 缺陷台账定时器
      // 工作票台账数据集合
      markerGZPTZInfos: [],
      markerGZPTZDatas: [
        {
          pos: [143.32032775878906, 143.34642028808594, 26.700000762939453],
          text: '测点1：i11134234324' + '\n' + '测点2：534534344',
        },
        {
          pos: [154.49493408203125, 233.83433532714844, 35.82297897338867],
          text: 'ces22222',
        },
        {
          pos: [206.1922149658203, 125.38224792480469, -0.4000000059604645],
          text: 'ces3331',
        },
      ],
      GZPTZTimer: null, // 工作票台账定时器
      // 实时参数数据集合
      markerSSCSInfos: [], // 实时参数指针集合
      markerSSCSDatas: [], // 实时参数数据
      socketObject: null,
      sisTagCodes: [], // 测试时的tagcode数据集合
      flag: true, // 模拟测试数据变化
    }
  },
  mounted() {
    window.addEventListener(
      'message',
      (e) => {
        if (e.data && this.player && this[e.data.method]) {
          try {
            this[e.data.method](e.data.params)
          } catch (error) {
            console.log(error)
          }
        }
      },
      false
    )
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    sisMarkerMaxVisibleRange() {
      const systemParams = this.$store.getters.systemParams || []
      const obj = _.find(systemParams, { parameterCode: 'sisMarkerMaxVisibleRange' })
      return obj ? obj.parameterValue : ''
    },
  },
  watch: {
    comPlayer(val) {
      if (val) {
        this.player = val
        this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.markerClick)
      }
    },
    markerSSCSDatas: {
      handler: function(newVal) {
        // 创建新的标签前，判断是否是更新标记
        if (this.markerSSCSInfos.length) {
          console.log('----更新-----')
          // 更新
          _.forEach(newVal, async (val) => {
            let pos = await getItemPosByCode(val.tagCode)
            let text = _.join(
              _.map(val.pointList, (item) => {
                return `${item.pointName}:${item.pointValue}${item.unit}`
              }),
              '\n'
            )
            _.forEach(this.markerSSCSInfos, async (val1) => {
              if (val1.kks === val.tagCode) {
                await updateMarker(val1.markerId, {
                  text,
                })
              }
            })
          })
        } else {
          console.log('----创建-----')
          // 创建
          _.forEach(newVal, async (val) => {
            let pos = await getItemPosByCode(val.tagCode)
            let text = _.join(
              _.map(val.pointList, (item) => {
                return `${item.pointName}:${item.pointValue}${item.unit}`
              }),
              '\n'
            )
            // 创建SIS实时数据标签
            const markerId = await drawTextLabel(
              pos,
              text,
              text.length,
              1,
              val.color,
              this.sisMarkerMaxVisibleRange
            )
            this.markerSSCSInfos.push({
              markerId,
              kks: val.tagCode,
              pointCodes: _.map(val.pointList, 'pointCode'),
            })
          })
        }
      },
      deep: true,
    },
    async markerQXTZDatas(newVal, oldVal) {
      // 判断里面的数据，如果创建过的标记就是不在创建，没有创建过就新增
      let oldKks = _.map(oldVal, 'instanceNumber')
      let newKks = _.map(newVal, 'instanceNumber')
      // 差集（旧相对新）,删除
      const nodeList = []
      const deleteData = _.filter(oldVal, (item) => {
        return !_.includes(newKks, item.instanceNumber)
      })
      for (let i = 0; i < deleteData.length; i++) {
        const index = _.indexOf(_.map(this.markerQXTZInfos, 'kks'), deleteData[i].instanceNumber)
        const removeMarkerInfo = _.find(this.markerQXTZInfos, ['kks', deleteData[i].instanceNumber])
        if (removeMarkerInfo) {
          await this.player.Native.GisMarker.destroy(removeMarkerInfo.markerId)
          this.markerQXTZInfos.splice(index, 1)
        }
      }
      // 差集（新相对旧），创建
      const createData = _.filter(newVal, (item) => {
        return !_.includes(oldKks, item.instanceNumber)
      })
      // 绘制标签
      const imgId = await PlayerUtils.call(
        this.player.Native.GisMarker.loadImage,
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/icon/upper.png`
      )
      let pos = null
      for (let m = 0; m < createData.length; m++) {
        pos = await getItemPosByCode(createData[m].instanceNumber)
        const markerId = await drawMarker(pos, imgId, [20, 24], [20, 24], [-10, -12])
        this.markerQXTZInfos.push({ markerId, kks: createData[m].instanceNumber })
      }
      //交集，更新
    },
  },
  methods: {
    // 显示影藏台账标签
    async visibleMarkers(params) {
      let curTimerKey = `${params.type}Timer`
      let curMarkerInfosKey = `marker${params.type}Infos`
      let curgetListKey = `get${params.type}List`
      let curDataKey = `marker${params.type}Datas`
      if (params.tagCodes) {
        this.sisTagCodes = params.tagCodes
      } else {
        this.sisTagCodes = []
      }
      // 清除定时器
      if (this[curTimerKey]) {
        clearInterval(this[curTimerKey])
        this[curTimerKey] = null
      }
      if (params.visible) {
        await this[curgetListKey]()
        if (params.type !== 'SSCS') {
          this[curTimerKey] = setInterval(async () => {
            console.log(curTimerKey, '---curTimerKey---')
            await this[curgetListKey]()
          }, 100000)
        }
      } else {
        // 如果是关闭标签，卸载创建的标签
        if (this[curMarkerInfosKey].length) {
          await destroyMarker(this[curMarkerInfosKey])
          this[curMarkerInfosKey] = []
          this[curDataKey] = []
        }
        // 实时参数
        if (params.type === 'SSCS' && this.socketObject) {
          // 关闭websocket推送
          this.socketObject.close()
          this.socketObject = null
        }
      }
    },
    // 标签的点击事件
    async markerClick(res) {
      console.log(res, '---res-----res---')
      const markerInfo = _.find(
        [...this.markerGZPTZInfos, ...this.markerQXTZInfos, ...this.markerSSCSInfos],
        ['markerId', res.markerId]
      )
      if (markerInfo) {
        const org_id = await this.getAttributeInfo(markerInfo.kks)
        markerInfo.orgId = org_id
        window.parent.postMessage({ params: markerInfo, method: 'iframeMarkerClick' }, '*')
      }
    },
    // 通过code获取位号信息
    async getAttributeInfo(code) {
      const res = await DocumentService.getTagInfoByCode({
        code,
      })
      if (res && res.code === 0 && _.keys(res.data).length) {
        const orgId =
          _.find(res.data.generalAttrSet.attrValueList, ['fieldName', 'org_id']).attrValue || ''
        return orgId
      }
    },
    // 获取缺陷台账数据
    async getQXTZList() {
      console.log(11223333, this.markerQXTZInfos)
      // this.flag = !this.flag
      // if(this.flag){
      //   this.markerQXTZDatas = [
      //     {
      //       instanceNumber: 'T0306-F-TR-(36.000m)',
      //     },
      //     {
      //       instanceNumber: 'S6402-S-(13.200m)-FL',
      //     },
      //     {
      //       instanceNumber: 'T0321-S-(23.000m)-FL',
      //     },
      //   ]
      // } else {
      //   this.markerQXTZDatas = [
      //     {
      //       instanceNumber: 'T0702-S-(5.700m)-BE',
      //     },
      //     {
      //       instanceNumber: 'T0617-S-(5.700m)-FL',
      //     },
      //     {
      //       instanceNumber: 'T0321-S-(23.000m)-FL',
      //     },
      //   ]
      // }
      // 调用请求（查询未消缺的缺陷对应的设备kks）
      const { data: res } = await axios.get(
        `http://10.67.237.168:80/smart/web/EmEquipment/queryEquipForBug`
      )
      if (res.flag === 'success' && res.statusCode === 200) {
        this.markerQXTZDatas = res.result
      }
    },
    // 获取工作票台账数据
    async getGZPTZList() {
      // 调用请求(查询所有有效的工作票对应的设备kks)
      // 请求成功整理数据
      // 绘制标签
      const imgId = await PlayerUtils.call(
        this.player.Native.GisMarker.loadImage,
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/icon/tower_yellow.png`
      )
      _.forEach(this.markerGZPTZDatas, async (val) => {
        const markerId = await drawMarker(val.pos, imgId, [20, 24], [20, 24], [-10, -12])
        this.markerGZPTZInfos.push({ markerId, kks: val.text, orgId: val.text })
      })
    },
    // 获取实时参数数据 内网测试：9#-EQUI-D0301  外网：10CJA10GK001-A13
    async getSSCSList() {
      const res = await LocalSense.getSSCSListDatas({
        tagCodes: this.sisTagCodes,
      })
      if (res && res.code === 0 && res.data) {
        let pointLists = []
        let OutRes = _.cloneDeep(res.data)
        for (let i = 0; i < OutRes.length; i++) {
          for (let j = 0; j < OutRes[i].pointList.length; j++) {
            pointLists.push(OutRes[i].pointList[j].pointCode)
          }
        }
        this.socketObject = new WebSocket(currentEnv.VUE_APP_SSCS_SERVER)
        this.socketObject.onopen = () => {
          console.log('服务建立连接成功！')
        }
        this.socketObject.onmessage = ({ data }) => {
          if (data.indexOf('连接成功') === 0) {
            console.log('连接成功!')
          } else {
            const InnerRes = JSON.parse(data)
            _.forEach(OutRes, (el) => {
              _.forEach(el.pointList, (el1) => {
                let curObj = _.find(InnerRes, ['GN', el1.pointCode]) || {}
                el1.pointValue = curObj.AV
              })
            })
            this.markerSSCSDatas = OutRes
          }
        }
        this.socketObject.onclose = () => {
          console.log('连接断开---')
        }
        this.socketObject.onerror = (msg) => {
          this.$message.error('连接错误')
        }
        setTimeout(() => {
          // 传递参数
          let params = { PointCodeList: pointLists }
          if (this.socketObject.readyState === 1) {
            this.socketObject.send(JSON.stringify(params))
          }
        }, 500)
      } else {
        this.$message.error(res.message)
      }
    },
  },
  destroyed() {
    if (this.player) {
      this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.markerClick)
      // 卸载标记
      destroyMarker([...this.markerGZPTZInfos, ...this.markerQXTZInfos, ...this.markerSSCSInfos])
      if (this.GZPTZTimer) {
        clearInterval(this.GZPTZTimer)
        this.GZPTZTimer = null
      }
      if (this.QXTZTimer) {
        clearInterval(this.QXTZTimer)
        this.QXTZTimer = null
      }
    }
  },
}
</script>

<style>

</style>
